<template>
  <div>
    <button
      class="btn"
      type="button"
      @click.stop="openModal"
    >
      {{ trans_choice('core.results',2) }}
    </button>

    <modal
      :open="open"
      :title="title"
      @close="closeModal"
    >
      <h4 class="title">
        {{ question.question }}
      </h4>
      <open-question-result
        :responses="event.answers.data[0]"
        :remarks="remarks"
        :max-height="false"
      />
    </modal>
  </div>
</template>
<script>
import Modal from '../../../../students/student-calendar/components/Modal'
import OpenQuestionResult from '../results/employees/OpenQuestionResult'

export default {

  name: 'OpenQuestionResultModal',

  components: {
    Modal, OpenQuestionResult,
  },
  props: {
    question: {
      required: true,
    },
    event: {
      required: true,
    },
  },

  data () {
    return {
      open: false,
    }
  },

  computed: {

    remarks () {
      return this.event.remarks.data
    },

    title () {
      return Lang.get('core.answer') + ' ' + this.event.full_name + ' (' + this.event.date + ')'
    },
  },

  watch: {},

  methods: {
    openModal () {
      this.open = true
    },
    closeModal () {
      this.open = false
    },
  },
}
</script>
<style scoped>

.title{
  width: 100%;
}
</style>
